import { useState, useEffect } from "react";
import {
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useRuns } from "contexts/RunsContext";

export default function EditRunMenuItem({ run, onClick }) {
  const [editOpen, setEditOpen] = useState(false);
  const [newName, setNewName] = useState(run.name);
  const [newDescription, setNewDescription] = useState(run.description || "");
  const { patchRun } = useRuns();

  useEffect(() => {
    setNewName(run.name);
    setNewDescription(run.description || "");
  }, [run.name, run.description]);

  const onCancel = () => {
    setEditOpen(false);
  };

  const onSave = () => {
    if (newName !== run.name) {
      patchRun(run.id, "name", newName);
    }
    if (newDescription !== run.description) {
      patchRun(run.id, "description", newDescription);
    }
    setEditOpen(false);
  };

  return (
    <>
      <MenuItem
        onClick={(e) => {
          e.stopPropagation();
          setEditOpen(true);
          onClick();
        }}
      >
        <Edit sx={{ mr: 1 }} fontSize="small" />
        Edit
      </MenuItem>
      <Dialog open={editOpen} onClose={onCancel}>
        <DialogTitle>Edit Simulation Info</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            variant="outlined"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            label="Description"
            type="text"
            fullWidth
            variant="outlined"
            value={newDescription}
            onChange={(e) => setNewDescription(e.target.value)}
            multiline
            rows={4}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel}>Cancel</Button>
          <Button onClick={onSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
